import { useLang } from "@/constants/i18n";

const Sequence = ({ items, hidden }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
        {items.map((item) => (
            <span key={`${item}-${hidden}`} className="flex items-center">
                <span className="whitespace-nowrap px-10 font-serif text-2xl font-light italic tracking-wide text-forest/50 md:text-3xl">
                    {item}
                </span>
                <span className="h-2 w-2 rotate-45 bg-gold/60" />
            </span>
        ))}
    </div>
);

export const Marquee = () => {
    const { t } = useLang();
    return (
        <div
            data-testid="editorial-marquee"
            className="overflow-hidden border-y border-gold/25 bg-ivory py-7"
        >
            <div className="flex w-max animate-marquee" key={t.marquee.items[2]}>
                <Sequence items={t.marquee.items} hidden={false} />
                <Sequence items={t.marquee.items} hidden={true} />
            </div>
        </div>
    );
};

export default Marquee;
